import authReducer from "./auth"

export default authReducer
